import { FunctionComponent } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { InvoiceListRecord } from '@spike/invoice-model';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { mediaQueries } from 'hooks/useBreakpoints';
import styles from './VoidInvoiceModal.module.scss';

export interface VoidInvoiceModalProps {
    invoice: Pick<InvoiceListRecord, 'uuid'> | null;
    voiding?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}

const VoidInvoiceModalContent: FunctionComponent<{
    voiding?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}> = ({ voiding = false, zIndex, onClose, onConfirm }) => {
    const isMobile = useMediaQuery(`(max-width:${mediaQueries.down.sm})`);

    return (
        <GenericModal
            fullScreen={isMobile}
            zIndex={zIndex}
            onClose={voiding ? undefined : onClose}
            footer={
                <div className={styles.footer}>
                    <div className={styles.footerAction}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Cancel"
                            onClick={onClose}
                            variant="black"
                            disabled={voiding}
                        />
                    </div>
                    <div className={styles.footerAction}>
                        <Button
                            label={voiding ? 'Voiding...' : 'Yes'}
                            size="large"
                            className={styles.button}
                            onClick={onConfirm}
                            variant="danger"
                            isLoading={voiding}
                            disabled={voiding}
                        />
                    </div>
                </div>
            }
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Void Invoice?</span>
                <p className={styles.description}>
                    This invoice will be marked as voided and will remain visible in the invoice list for record
                    purposes. This action cannot be undone.
                </p>
            </div>
        </GenericModal>
    );
};

export const VoidInvoiceModal: FunctionComponent<VoidInvoiceModalProps> = ({
    invoice,
    voiding,
    zIndex,
    onClose,
    onConfirm
}) => {
    if (!invoice) {
        return null;
    }

    return (
        <VoidInvoiceModalContent
            key={invoice.uuid}
            voiding={voiding}
            zIndex={zIndex}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default VoidInvoiceModal;
